import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslocoService} from '@ngneat/transloco';
import {AbstractComponent} from "@components";
import {
  EventItem,
  EventPaymentSettings, Lookups,
  OrganiserPaymentData,
  Race,
  RaceAdditionalPricingItem,
  RaceCommercialItem
} from "@model";
import {EventPaymentSettingsService, OrganiserPaymentDataService} from "@services";

@Component({
    selector: 'app-race-details-pricing',
    templateUrl: './race-details-pricing.component.html',
    styleUrls: ['./race-details-pricing.component.scss'],
    standalone: false
})
export class RaceDetailsPricingComponent extends AbstractComponent {
  @Input() event: EventItem | undefined;
  @Input() race: Race | undefined;
  @Input() disableEditing: boolean = false;
  @Input() raceCommercialItems: RaceCommercialItem[] = [];
  @Input() raceAdditionalItems: RaceAdditionalPricingItem[] = [];
  @Input() currencies: Lookups[] = [];
  @Input() visibilityTypes: Lookups[] = [];
  @Input('registrationDisplayFlags') displayFlags: Lookups[] = [];
  @Input() registrationFeeTypes: Lookups[] = [];
  @Input() editingEnabled: boolean = false;
  @Input({required: true}) languages: Lookups[] = [];

  @Output() raceCommercialItemsChanged = new EventEmitter<RaceCommercialItem[]>();
  @Output() raceAdditionalItemsChanged = new EventEmitter<RaceAdditionalPricingItem[]>();

  eventPaymentSettings: EventPaymentSettings | null = null;
  organiserPaymentData: OrganiserPaymentData | null = null;

  constructor(public translocoService: TranslocoService,
              private organiserPaymentDataService: OrganiserPaymentDataService,
              private eventPaymentSettingsSerivce: EventPaymentSettingsService) {
    super();
  }

  ngOnInit() {
    if (this.event?.id) {
      this.eventPaymentSettingsSerivce.fetchEventPaymentSettingsById(this.event.id).subscribe((eventPaymentSettings: EventPaymentSettings | null) => {
        this.eventPaymentSettings = eventPaymentSettings;
      });
    }
    if (this.event?.organiserId) {
      this.organiserPaymentDataService.fetchOrganiserPaymentData(this.event.organiserId).subscribe((organiserPaymentData: OrganiserPaymentData | null) => {
        this.organiserPaymentData = organiserPaymentData;
      });
    }
  }

  onRaceCommercialItemsChanged(raceCommercialItems: RaceCommercialItem[]): void {
    this.raceCommercialItemsChanged.emit(raceCommercialItems);
  }

  onRaceAdditionalItemsChanged(raceAdditionalItems: RaceAdditionalPricingItem[]): void {
    this.raceAdditionalItemsChanged.emit(raceAdditionalItems);
  }
}
